var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ex-checkpoint-badge"},[_c('v-chip',{class:_setup.classes},[_c('span',{staticClass:"prop-status-label",class:_setup.textClasses},[_vm._v(_vm._s(_setup.levelLabel)+" Level")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }